import React from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Rahul Sharma',
      role: 'Property Buyer',
      rating: 5,
      text: 'Excellent service! The team at Jeevika Property helped me find my dream home in Vasai West. Very professional and responsive throughout the process.',
      image: 'https://ui-avatars.com/api/?name=Rahul+Sharma&background=1e40af&color=fff&size=100'
    },
    {
      id: 2,
      name: 'Priya Patel',
      role: 'Apartment Owner',
      rating: 5,
      text: 'Sold my apartment within a month at a great price. Their market knowledge and negotiation skills are outstanding. Highly recommended!',
      image: 'https://ui-avatars.com/api/?name=Priya+Patel&background=3b82f6&color=fff&size=100'
    },
    {
      id: 3,
      name: 'Amit Desai',
      role: 'Commercial Property',
      rating: 5,
      text: 'Best real estate consultant in Vasai! They helped me find the perfect office space for my business. Professional and trustworthy team.',
      image: 'https://ui-avatars.com/api/?name=Amit+Desai&background=1e40af&color=fff&size=100'
    },
    {
      id: 4,
      name: 'Sneha Kulkarni',
      role: 'First-time Buyer',
      rating: 5,
      text: 'As a first-time buyer, I was worried about the process. Jeevika Property made it so easy and guided me every step of the way. Thank you!',
      image: 'https://ui-avatars.com/api/?name=Sneha+Kulkarni&background=3b82f6&color=fff&size=100'
    }
  ];

  return (
    <section className="testimonials section-padding" id="testimonials">
      <div className="container">
        <div className="section-title">
          <h2>Client Testimonials</h2>
          <p>What Our Happy Clients Say About Us</p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div className="testimonial-card" key={testimonial.id}>
              <FaQuoteLeft className="quote-icon" />
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <img src={testimonial.image} alt={testimonial.name} />
                <div>
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;